import config from "config/config";
import { getToken } from "js/formatting/getToken";
export async function updateUserEmailOptions(
  userId,
  contractId,
  oldContractId,
  updatedEmailOption,
  currentEmailOption,
  ownerType
) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      userId,
      contractId,
      oldContractId,
      updatedEmailOption,
      currentEmailOption,
      ownerType,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/emailoption",
    options
  );

  if (response.ok) {
    return;
  } else {
    throw response;
  }
}
